var React = require('react');

function Checkbox (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"x":"45","y":"88","width":"24","height":"24","fill":"#404040","key":1}),React.createElement("path",{"d":"M49.2893 103.189L52.4203 106.352C53.3248 107.266 54.7988 107.274 55.7125 106.369C55.7866 106.296 55.8558 106.217 55.9194 106.135L64.7924 94.6101C65.1293 94.1725 65.0477 93.5446 64.61 93.2077C64.1724 92.8708 63.5446 92.9524 63.2076 93.39L54.3347 104.915C54.1768 105.075 53.9691 105.074 53.8417 104.945L50.7107 101.782C50.3222 101.39 49.689 101.387 49.2965 101.775C48.904 102.164 48.9008 102.797 49.2893 103.189Z","fill":"white","key":2}),React.createElement("rect",{"x":"85","y":"88","width":"158","height":"24","fill":"#D8D8D8","key":3})]);
}

Checkbox.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = Checkbox;

Checkbox.default = Checkbox;
